<template>
  <div v-if="roomId && room?.room_id" class="p-4">
    <div
      class="highlighted-room-card border-0 border-b border-solid border-grey-300 pb-4 mb-8"
      :class="{'-mt-3 md:-mt-5': store.state.rooms.length}"
    >
      <div class="text-base im:text-xl font-semibold mb-4">
        The venue you selected
      </div>

      <RoomCard
        v-if="!isHorizontalRoomCard"
        :room="room"
        :manager-last-activity-online="managersLastActivityOnline[room.venue_id]"
        :index="-1"
        @trackClick="roomCardClick"
        @beforeSlide="onBeforeSlideChange"
      />
      <RoomCardHorizontal
        v-else
        class="mb-2 pb-2"
        :room="room"
        :manager-last-activity-online="managersLastActivityOnline[room.venue_id]"
        :index="-1"
        :force-features-visibility-ids="forceFeaturesVisibilityIds"
        @trackClick="roomCardClick"
        @beforeSlide="onBeforeSlideChange"
      />
    </div>

    <div v-if="store.state.rooms.length" class="text-xl im:text-2xl font-semibold">
      Explore more venues
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';

import useCustomBreakpoints from '@/utils/custom-breakpoints';

import RoomCard from './RoomCard.vue';
import RoomCardHorizontal from './RoomCardHorizontal.vue';

const store = useStore();

const roomId = computed(() => store.state.highlightedRoomId);
const room = computed(() => store.state.highlightedRoomData);
const managersLastActivityOnline = computed(() => store.state.managersLastActivityOnline);

const breakpoints = useCustomBreakpoints();
const isHorizontalRoomCard = computed(() => ['sm', 'md', 'il', 'lg'].includes(breakpoints.active().value));

const facilitiesPerGroup = {
  meeting: [5, 13, 8, 7, 11],
  business: [5, 12, 8, 7, 9],
  wedding: [1, 2, 12, 17, 3],
  party: [1, 2, 12, 17],
  production: [5, 6, 12, 16, 7],
};
const venueTypeTagCategory = room.value?.venue_type_tag_category;
const forceFeaturesVisibilityIds = facilitiesPerGroup[venueTypeTagCategory] || [];

const roomCardClick = () => {
  App.track.event('search_page_interaction', {
    section: 'list',
    element: 'horizontal_room_card',
    element_value: roomId.value,
    interaction: 'click',
  });
};
const onBeforeSlideChange = (e) => {
  App.track.event('search_page_interaction', {
    section: 'list',
    element: 'horizontal_room_card',
    element_value: roomId.value,
    interaction: e.arrowDirection === 'left ' ? 'photo_prev' : 'photo_next',
  });
};
</script>

<style lang="scss" scoped>
@media (min-width: 991px) and (max-width: 1280px) {
  .highlighted-room-card :deep(.c-room-card) {max-width: calc(var(--width-1-2, 50%) - 13px);}
  // 13px is half of margin between cards (used on search view) (.v-search-results-items .c-room-card)
}
</style>
